module.exports = __webpack_public_path__ + "static/media/forskjellsbehandle.3e8373e9.m4a";